import cn from "classnames";
import { ColumnSizeProps } from "../typings/sizes";

export const useColumnSizeProps = <T extends ColumnSizeProps>(props: T) => {
  const { col, className, sm, md, lg, xl, ...rest } = props;
  const output: string = cn({
    [`col-${col}`]: col,
    [`col-sm-${sm}`]: sm,
    [`col-md-${md}`]: md,
    [`col-lg-${lg}`]: lg,
    [`col-xl-${xl}`]: xl,
    className,
  });

  return { className: output, ...rest };
};
